/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: LGPL-2.1-only
 */
:host {
  display: inline-block;
  width: 100%;
}

.accordion {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--qds-list-item-large-gap-internal);
}
